import {rwxCanvas, rwxMath, rwxAnimate, rwxDOM, rwxMisc, rwxGeometry} from 'roseworx/js/helpers/rwxHelpers';

var stopAnimations = true;
var fromToDemoAnimation, fromToBezierDemoAnimation;
var resultColor = "#3eee3e";

window.addEventListener('load', ()=>{
	slideToggleDemo();
	slideUpDemo();
	slideDownDemo();
	getCookieDemo();
	shuffleArrayDemo();
	safeCloneArrayOfObjectsDemo();
	safeCloneObjectDemo();
	safeCloneArrayDemo();
	uniqueIdDemo();
	randomIntDemo();
	randomFloatDemo();
	toRadiansDemo();
	getQuadraticBezierLengthDemo();
	getDistanceDemo();
	isInsideCircleDemo();
	isInsideSectorDemo();
	isInsideArcDemo();
	closestPointOnCircumferenceDemo();
	drawSectorDemo();
	drawArcDemo();
	fromToDemo();
	fromToBezierDemo();
		rwx.tabs.addTabChangeEvent('js-helpers', 3, ()=>{stopAnimations = false; fromToDemoAnimation(); fromToBezierDemoAnimation();}, 'show');
		rwx.tabs.addTabChangeEvent('js-helpers', 3, ()=>{stopAnimations = true}, 'hide');
});

function canvasdemo(id, result)
{
	const color = resultColor;
	const canvas = document.getElementById(`${id}-demo`);
	if(!canvas){console.log(`No Demo Canvas ID Found ${id}`); return false;}
	const ctx = canvas.getContext('2d');
	rwxCanvas.scale(canvas, ctx, 300, 300);
	const resultel = document.getElementById(`${id}-result`);
	if(resultel && result){
		resultel.style.color = color;
		resultel.textContent = `Result : ${result}`
	};
	ctx.strokeStyle = color;
	ctx.fillStyle = color;
	ctx.lineWidth = 3;
	return ctx;
}

function justresultdemo(id, result, result2 = false)
{
	const resultel = document.getElementById(`${id}-result`);
	if(resultel)
	{
		resultel.style.color = resultColor;
		let res = `Result : ${result}`;
		if(result2){ res+= `\r\n${result2}`; resultel.style.whiteSpace = "pre";}
		resultel.textContent = res;
	}
}

function slideDemo(name)
{
	const el = document.getElementById(`${name}-demo`);
	const action = document.getElementById(`${name}-demo-action`);
	action.addEventListener('click', ()=>{
		rwxDOM[name](el, 1, ()=>{console.log("done")});
	})	
}

function slideToggleDemo()
{
	slideDemo('slideToggle');
}

function slideDownDemo()
{
	document.getElementById('slideDown-demo').style.display = "none";
	slideDemo('slideDown');
}

function slideUpDemo()
{
	slideDemo('slideUp')
}

function getCookieDemo()
{
	justresultdemo('getCookie', "Is Great");
}

function shuffleArrayDemo()
{
	let arr = ['a', 'b', 'c', 'd', 'e', 'f'];
	rwxMisc.shuffleArray(arr);
	justresultdemo('shuffleArray', JSON.stringify(arr));
}

function safeCloneArrayOfObjectsDemo() {
	const arr = [{ a: "b" }, { c: "d" }, { e: "f" }];
	const result = rwxMisc.safeCloneArrayOfObjects(arr);
	arr[0] = { g: "h" };
	arr[2].e = "i";
	justresultdemo('safeCloneArrayOfObjects', JSON.stringify(result), `arr: ${JSON.stringify(arr)}`);
}

function safeCloneObjectDemo() {
	const obj = {a: "b", c: "d", e: "f"};
	const result = rwxMisc.safeCloneObject(obj);
	obj.a = "g";
	justresultdemo('safeCloneObject',JSON.stringify(result), `obj: ${JSON.stringify(obj)}` );
}

function safeCloneArrayDemo() {	
	const arr = ['a', 'b', 'c', 'd', 'e', 'f'];
	const result = rwxMisc.safeCloneArray(arr);
	arr[3] = "g";
	justresultdemo('safeCloneArray', JSON.stringify(result), `arr: ${JSON.stringify(arr)}`);
}

function uniqueIdDemo() {
	justresultdemo('uniqueId', rwxMisc.uniqueId());
}

function randomFloatDemo()
{
	justresultdemo('randomFloat', rwxMath.randomFloat(0,1));
}

function randomIntDemo()
{
	justresultdemo('randomInt', rwxMath.randomInt(0,10));
}

function fromToBezierDemo()
{
	const ctx = canvasdemo('fromToBezier');
	if(!ctx)return;
	fromToBezierDemoAnimation = function animate()
	{
		if(stopAnimations)return;
		ctx.clearRect(0,0,window.innerWidth,window.innerHeight);
		let {x,y} = rwxAnimate.fromToBezier({x: 40, y:40}, {x: 70, y:300}, {x: 300, y:0}, {x: 260, y:260}, 'circleBezier', 'easeInOutQuint', 2000, ()=>{console.log("fromToBezier done")});
		ctx.beginPath();
		ctx.arc(x, y, 20, 0, 2 * Math.PI);
		ctx.stroke();
		ctx.fill();	
		window.requestAnimationFrame(fromToBezierDemoAnimation);
	}
	fromToBezierDemoAnimation();
}

function fromToDemo()
{
	const ctx = canvasdemo('fromTo')
	if(!ctx)return;
	fromToDemoAnimation = function animate()
	{
		if(stopAnimations)return;
		ctx.clearRect(0,0,window.innerWidth,window.innerHeight);
		let x = rwxAnimate.fromTo(40, 260, 'circle1x', 'easeInOutQuad', 2000, ()=>{console.log("fromTo done")});
		let y = rwxAnimate.fromTo(40, 260, 'circle1y', 'easeInOutQuad', 2000);
		ctx.beginPath();
		ctx.arc(x, y, 20, 0, 2 * Math.PI);
		ctx.stroke();
		ctx.fill();	
		window.requestAnimationFrame(fromToDemoAnimation);	
	}
	fromToDemoAnimation();
}

function drawSectorDemo()
{
	const ctx = canvasdemo('drawSector');
	if(!ctx)return;
	rwxCanvas.drawSector(ctx, {x:150, y:150}, 150, rwxGeometry.toRadians(270), rwxGeometry.toRadians(360));
}

function drawArcDemo()
{
	const ctx = canvasdemo('drawArc');
	if(!ctx)return;
	rwxCanvas.drawArc(ctx, {x:150, y:150}, 150, 50, rwxGeometry.toRadians(180), rwxGeometry.toRadians(240));
}

function toRadiansDemo()
{
	justresultdemo('toRadians', rwxGeometry.toRadians(30));
}

function getQuadraticBezierLengthDemo()
{
	const ctx = canvasdemo('getQuadraticBezierLength', rwxGeometry.getQuadraticBezierLength({x:50, y:50}, {x:333, y:33}, {x:250, y:250}));
	if(!ctx)return;
	ctx.beginPath();
	ctx.moveTo(50, 50);
	ctx.quadraticCurveTo(333, 33, 250, 250);	
	ctx.stroke();
	ctx.closePath();
}

function getDistanceDemo()
{
	const ctx = canvasdemo('getDistance', rwxGeometry.getDistance({x:35, y:35}, {x:265, y:265}));
	if(!ctx)return;
	ctx.beginPath();
	ctx.moveTo(35, 35);
	ctx.lineTo(265, 265);
	ctx.stroke();
	ctx.closePath();
	ctx.strokeStyle = "#000000";
	ctx.beginPath();
	ctx.arc(35, 35, 10, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
	ctx.beginPath();
	ctx.arc(265, 265, 10, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
}

function isInsideCircleDemo()
{
	const ctx = canvasdemo('isInsideCircle', rwxGeometry.isInsideCircle({x:175, y:175}, {x:150, y:150}, 100));
	if(!ctx)return;
	ctx.beginPath();
	ctx.arc(175, 175, 10, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
	ctx.strokeStyle = "#000000";
	ctx.beginPath();
	ctx.arc(150, 150, 100, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
}

function isInsideSectorDemo()
{
	const ctx = canvasdemo('isInsideSector', rwxGeometry.isInsideSector({x:200, y:50}, {x:150, y:150}, 150, rwxGeometry.toRadians(270), rwxGeometry.toRadians(360)));
	if(!ctx)return;
	ctx.beginPath();
	ctx.arc(200, 50, 10, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
	ctx.strokeStyle = "#000000";
	ctx.globalCompositeOperation = 'destination-over';
	rwxCanvas.drawSector(ctx, {x:150, y:150}, 150, rwxGeometry.toRadians(270), rwxGeometry.toRadians(360));
}

function isInsideArcDemo()
{
	const ctx = canvasdemo('isInsideArc', rwxGeometry.isInsideArc({x:50, y:100}, {x:150, y:150}, 150, 100, rwxGeometry.toRadians(180), rwxGeometry.toRadians(240)));
	if(!ctx)return;
	ctx.beginPath();
	ctx.arc(50, 100, 10, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
	ctx.strokeStyle = "#000000";
	ctx.globalCompositeOperation = 'destination-over';
	rwxCanvas.drawArc(ctx, {x:150, y:150}, 150, 50, rwxGeometry.toRadians(180), rwxGeometry.toRadians(240));
}

function closestPointOnCircumferenceDemo()
{
	let res = rwxGeometry.closestPointOnCircumference({x:130, y:190}, {x:150, y:150}, 100);
	const ctx = canvasdemo('closestPointOnCircumference', `{x: ${res.x}, y: ${res.y}}`);
	if(!ctx)return;
	ctx.beginPath();
	ctx.arc(res.x, res.y, 10, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
	ctx.strokeStyle = "#000000";
	ctx.beginPath();
	ctx.arc(130, 190, 10, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
	ctx.beginPath();
	ctx.arc(150, 150, 100, 0, 2 * Math.PI);
	ctx.stroke();
	ctx.closePath();
}